export const ADMIN_PAGE_VIEWS_API = {
  COMPANIES: '/admins/page_views/companies',
  PROJECTS: '/admins/page_views/projects',
  RETRIEVE_DATA: '/admins/page_views/retrieve_data',
  EXPORT: '/admins/page_views/export',
};

export const ADMIN_PAGE_VIEWS_QUERY_KEYS = {
  COMPANIES: 'adminCompanies',
  PROJECT_OPTIONS: 'adminProjectOptions',
  PAGE_VIEWS: 'adminPageViews',
  EXPORT_STATUS: 'adminExportStatus',
};

export const ADMIN_PAGE_VIEWS_CONFIG = {
  DEFAULT_PER_PAGE: 10,
  POLLING_INTERVAL_MS: 5000,
};

export const ADMIN_PAGE_VIEW_CSV_DOWNLOAD = {
  DESCRIPTION: 'Please select a company, domain(s), and date range to export.',
}
